import type { FollowerAnimationDataJSON } from "../../types";
import followerAnimationDataJSON from "./follower.json";

const followerAnimationData = <FollowerAnimationDataJSON>followerAnimationDataJSON;
export { followerAnimationData };